import { redirectToRestaurants } from '../../config/navigation';

export default function Header() {
  return (
    <header className="bg-white/90 backdrop-blur-md border-b border-black/[0.06] sticky top-0 z-50">
      <div className="container-wide">
        <div className="flex items-center justify-between h-16 md:h-[68px]">
          {/* Logo */}
          <div className="flex items-center gap-2.5">
            <img src="/munchiesLogo.png" alt="Neighbourhood Munchies" className="h-9 w-auto" />
            <div className="leading-tight">
              <div className="text-[1.05rem] font-bold text-neutral-900 tracking-tight">
                Neighbourhood Munchies
              </div>
            </div>
          </div>

          {/* Nav */}
          <nav className="flex items-center gap-8">
            <a
              href="#features"
              className="hidden md:block text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors"
            >
              Features
            </a>
            <button
              onClick={() => redirectToRestaurants()}
              className="bg-neutral-900 text-white px-5 py-2 rounded-[10px] text-sm font-semibold hover:bg-neutral-700 transition-colors shadow-sm"
            >
              Order Now
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}
